import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {Progress} from 'reactstrap';
import {connect} from 'react-redux';
import Lottie from 'react-lottie';
import CheckedAnimation from '../../../animations/approved-checked-outline.json';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import PopUp from '../../Shared/Popup/PopUp';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import {
  getSurfingDataUsageDetails,
  addPackage,
  closePopUpExpanding,
  openPopUpExpanding,
  openPopUpLink,
  closePopUpLink,
  openPopUpAddPackageResult,
  closePopUpAddPackageResult,
  setSelectedSubscriber,
  reportAnalytics,
} from './CellularSurfingUseDetailsBlockSlice';
import {getFormatDate} from '../../../utilities/dateUtils';
import personIcon from './images/person.svg';
import moreInfoIcon from './images/moreInfo.svg';
import cycleRemainingDaysIcon from './images/cycleRemainingDays.svg';
import alertIcon from './images/alert.svg';
import arrowLeftIcon from './images/arrow-left.svg';
import mobileIcon from './images/mobile-icon.svg';
import {Col, Row, Container} from 'reactstrap';
import Config from '../../../Config';
import {isMobile} from 'react-device-detect';

const CellularDataUsage = (props) => {
  const [isFinishedGetSurfingDataUsageDetails, setIsFinishedGetSurfingDataUsageDetails] = useState(false);
  const [linkPopUpTitle, setLinkPopUpTitle] = useState('');
  const [linkPopUpText, setLinkPopUpText] = useState('');

  useEffect(() => {
    if (props.isFullAuthenticated) {
      getCellularList(false);
    }
  }, [props.isFullAuthenticated]);

  useEffect(() => {
    if (props.showPopUpAddPackageResult) {
      if (props.isSuccessAddPackage) {
        props.reportAnalytics({
          eventCategory: 'internet_usage_cellular',
          eventAction: 'visibility_6',
          eventLabel: 'element_10',
        });
      } else {
        props.reportAnalytics({
          eventCategory: 'internet_usage_cellular',
          eventAction: 'visibility_5',
          eventLabel: 'element_9',
        });
      }
    }
  }, [props.showPopUpAddPackageResult]);

  useEffect(() => {
    if (props.subscribers) {
      props.reportAnalytics({
        eventCategory: 'internet_usage_cellular',
        eventAction: 'visibility_1',
        eventLabel: props.subscribers.length,
      });

      props.subscribers.forEach((subscriber) => {
        if (subscriber.isPurchase1 || subscriber.isPurchase2 || subscriber.isPurchase3 || subscriber.isPurchase4) {
          props.reportAnalytics({
            eventCategory: 'internet_usage_cellular',
            eventAction: 'visibility_4',
            eventLabel: 'element_5',
          });
        }
      });
    }
  }, [props.subscribers]);

  async function getCellularList(isRefresh) {
    props.showAppLoader();
    setIsFinishedGetSurfingDataUsageDetails(false);
    await props.getSurfingDataUsageDetails({isPrivate: props.isPrivate, blockId: props.contentData.contentLink.id, isRefresh: isRefresh});
    setIsFinishedGetSurfingDataUsageDetails(true);
    props.hideAppLoader();
  }

  const setLinkContent = (item) => {
    if (item != null) {
      let linkText = '';
      let linkTitle = '';
      let tooltipContent = '';

      if (item.dataUsage.percentageUsed < 100 && item.dataUsage.percentageUsed >= props.contentData.displayLinkPercentValue.value) {
        linkText = 'מה יקרה כאשר החבילה תסתיים?';
        linkTitle = 'מה יקרה כאשר החבילה תסתיים?';
        tooltipContent = 'when_package_exceeded_max_size';
      } else if (item.dataUsage.percentageUsed >= 100 && item.dataOverhead.percentageUsed > 0) {
        linkText = 'להסבר';
        linkTitle = 'גלישה מעבר לחבילה';
        tooltipContent = 'MoreInfo';
      }

      if (item.isDisplayLink) {
        return (
          <div className='link'>
            <a href='javascript:void(0);' title={linkTitle} onClick={() => openPopUpLink(item)}>
              {linkText}
              <Image src={moreInfoIcon} title={tooltipContent} />
            </a>
          </div>
        );
      } else {
        return null;
      }
    }
  };

  const setLinkPopUpContent = (item) => {
    if (item != null) {
      let packageFinishedHatzara = 'בסיום חבילת הגלישה, הגלישה תיחסם עד סוף מחזור החיוב';
      let packageFinishedHariga =
        "בסיום חבילת הגלישה תחויבו ב {0} ₪ עבור כל {1} ג'יגה נוסף. ניתן להגיע במקסימום עד ל- {2} ג'יגה נוספים בסכום כולל של {3} ₪. לאחר מכן, הגלישה תיחסם עד סוף מחזור החיוב";
      let packageFinishedHarigaAgora =
        "בסיום חבילת הגלישה תועמד לרשותך חבילת גלישה בנפח GB {0} במסגרתה תחויב ב - 1 אג' עבור כל Mb 1 גלישה בפועל (מחיר החבילה בניצולה המלא הוא ₪{1} ) לאחר מכן תחול האטה משמעותית בגלישה עד לתום מחזור החיוב.";
      let explanation =
        "הסרגל הסגול מציג את הגלישה במסגרת החבילה שלכם. עם סיום חבילת הגלישה, תמשיכו לגלוש מחוץ לחבילה (הסרגל הוורוד), עבור כל  {0} ג'יגה תחויבו בעלות של {1} ₪, לאחר מכן עוד {0} ג'יגה  בעלות של  {1} ₪ נוספים וכך  עד לסה\"כ של {2} ג'יגה בעלות של {3} ₪. לאחר {2} ג'יגה מחוץ לחבילה, הגלישה תיחסם עד לסוף מחזור החיוב. במידה ובמחזור החיוב הנוכחי הוספתם הרחבה לחבילת הגלישה, ההרחבה תתווסף לחבילה המקורית שלכם (סרגל סגול). לדוגמה: אם החבילה המקורית שלכם כוללת 2 ג'יגה ובמחזור החיוב הנוכחי שלכם הוספתם עוד 10 ג'יגה, הסרגל הסגול יציג סה\"כ  12 ג'יגה.";
      let explanationAgora =
        "הסרגל הסגול מציג את הגלישה במסגרת החבילות שלכם. עם סיום חבילות הגלישה, תועמד לרשותך חבילת גלישה בנפח {0}GB במסגרתה תחויב ב- 1 אג' עבור כל Mb 1  גלישה בפועל (מחיר החבילה בניצולה המלא הוא ₪{1} ), לאחר מכן תחול האטה משמעותית בגלישה עד לתום מחזור החיוב.";

      packageFinishedHariga = packageFinishedHariga
        .replace('{0}', item.blockPrice)
        .replace('{1}', item.blockSize)
        .replace('{2}', item.totalBlockSize)
        .replace('{3}', parseFloat(item.blockPrice) * item.totalBlockSize);
      packageFinishedHarigaAgora = packageFinishedHarigaAgora.replace('{0}', item.blockSize).replace('{1}', item.blockPrice);
      explanation = explanation
        .replace('{0}', item.blockSize)
        .replace('{1}', item.blockPrice)
        .replace('{2}', item.totalBlockSize)
        .replace('{3}', parseFloat(item.blockPrice) * item.totalBlockSize);
      explanationAgora = explanationAgora.replace('{0}', item.blockSize).replace('{1}', item.blockPrice);

      if (item.dataUsage.percentageUsed < 100 && item.dataUsage.percentageUsed >= props.contentData.displayLinkPercentValue.value) {
        props.reportAnalytics({
          eventCategory: 'internet_usage_cellular',
          eventAction: 'click_1',
          eventLabel: 'element_3',
        });

        setLinkPopUpTitle('מה יקרה כאשר החבילה תסתיים?');
        if (item.isHatzara) {
          setLinkPopUpText(packageFinishedHatzara);
        }
        if (item.isHariga || (!item.isHatzara && !item.isHatzara)) {
          setLinkPopUpText(item.isAgora ? packageFinishedHarigaAgora : packageFinishedHariga);
        }
      } else if (item.dataUsage.percentageUsed >= 100 && item.dataOverhead.percentageUsed > 0) {
        props.reportAnalytics({
          eventCategory: 'internet_usage_cellular',
          eventAction: 'click_2',
          eventLabel: 'element_4',
        });

        setLinkPopUpTitle('גלישה מעבר לחבילה');
        setLinkPopUpText(item.isAgora ? explanationAgora : explanation);
      }
    }
  };

  const setPurchaseBox = (item) => {
    console.log(item);
    let newItem = item;
    var title = '';
    var content = '';
    if (newItem.canPurchase) {
      if (newItem.isPurchase1) {
        content = 'חבילת הגלישה שלך עשויה להסתיים לפני סוף מחזור החיוב.\n רוצה להרחיב את חבילת הגלישה ולהמשיך לגלוש בראש שקט?';
      } else if (newItem.isPurchase2) {
        content = 'חבילת הגלישה שלך הסתיימה, השימושים כעת במסגרת חריגה.\n רוצה להרחיב את חבילת הגלישה ולהמשיך לגלוש בראש שקט?';
      } else if (newItem.isPurchase3 || newItem.isPurchase4) {
        title = 'ניצלת את כל חבילת הגלישה';
        content = 'הגלישה נחסמה. רוצה להרחיב את חבילת הגלישה ולהמשיך לגלוש בראש שקט כבר מעכשיו?';
      }
    } else {
      if (newItem.isCantPurchase1 || newItem.isCantPurchase2) {
        title = 'ניצלת את כל חבילת הגלישה';
        content = 'הגלישה נחסמה. באפשרותך להמשיך לגלוש לאחר חידוש החבילה {0}'.replace(
          '{0}',
          newItem.isNextCycleDate ? 'בתאריך ' + newItem.nextCycleDate : ''
        );
      }
    }

    if (content != '') {
      return (
        <Row>
          <Col xs='12' sm='12' md='9'>
            <div className='purchase-wrapper'>
              <Row>
                <Col xs='12' sm='12' md='12'>
                  {title != '' && (
                    <div className='purchase-title'>
                      <Image src={alertIcon} className='alert-icon' />
                      {title}
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xs='12' sm='12' md='12'>
                  <div className='purchase-text'>
                    {title == '' && (
                      <span className='icon-wrapper'>
                        <Image src={alertIcon} className='alert-icon' />
                      </span>
                    )}
                    <p>
                      {content.split(/\r\n|\n|\r/gm).map((line) => {
                        return (
                          <p>
                            {line}
                            <br />
                          </p>
                        );
                      })}
                    </p>
                  </div>
                </Col>
              </Row>
              {item.canPurchase && (
                <a href='javascript:void(0);' onClick={() => openPopUpExpanding(item)}>
                  לפרטים ורכישה <Image src={arrowLeftIcon} className='left-arrow' />
                </a>
              )}
            </div>
          </Col>
        </Row>
      );
    } else {
      return null;
    }
  };

  const notFoundDataUsage = () => {
    props.reportAnalytics({
      eventCategory: 'internet_usage_cellular',
      eventAction: 'visibility_2',
      eventLabel: 'element_1',
    });

    return (
      <Row>
        <Col xs='12' sm='12' md='12'>
          <div className='not-found-subscribers'>
            <div>
              <Image src={mobileIcon} />
              <span style={{display: 'block'}}>תודה על פנייתך</span>
              <span style={{display: 'block'}}>לא נמצאו שימושי סלולר להצגה</span>
              <span style={{display: 'block'}}>יתכן שאין לך מנויי סלולר או שהם לא גולשים</span>
            </div>
            <a href={Config.lobbyUrl}>חזרה לאזור אישי</a>
          </div>
        </Col>
      </Row>
    );
  };

  const errorMsg = () => {
    props.reportAnalytics({
      eventCategory: 'internet_usage_cellular',
      eventAction: 'visibility_3',
      eventLabel: 'element_2',
    });

    return (
      <Row>
        <Col xs='12' sm='12' md='12'>
          <div className='not-found-subscribers'>
            <div>
              <Image src={mobileIcon} />
              <span style={{display: 'block'}}>תודה על פנייתך</span>
              <span style={{display: 'block'}}>בשל בעיה טכנית. כעת לא ניתן לצפות בשימושי גלישה שלך.</span>
              <span style={{display: 'block'}}>נסה שוב במועד מאוחר יותר.</span>
            </div>
            <a href={Config.lobbyUrl}>חזרה לאזור אישי</a>
          </div>
        </Col>
      </Row>
    );
  };

  const addPackage = async () => {
    props.reportAnalytics({
      eventCategory: 'internet_usage_cellular',
      eventAction: 'click_4',
      eventLabel: 'element_7',
    });

    props.showAppLoader();
    var soc = props.isPrivate ? props.contentData.socPrivate.value : props.contentData.socBusiness.value;
    await props.addPackage({subscriber: props.selectedSubscriber.cli, soc: soc});
    props.hideAppLoader();
    closePopUpExpanding();
    openPopUpAddPackageResult();
  };

  const closePopUpExpanding = () => {
    props.reportAnalytics({
      eventCategory: 'internet_usage_cellular',
      eventAction: 'click_5',
      eventLabel: 'element_8',
    });
    props.closePopUpExpanding();
  };

  const openPopUpExpanding = (item) => {
    props.reportAnalytics({
      eventCategory: 'internet_usage_cellular',
      eventAction: 'click_3',
      eventLabel: 'element_6',
    });
    props.setSelectedSubscriber(item);
    props.openPopUpExpanding();
  };

  const closePopUpLink = () => {
    props.closePopUpLink();
  };

  const openPopUpLink = (item) => {
    setLinkPopUpContent(item);
    props.openPopUpLink();
  };

  const closePopUpAddPackageResult = () => {
    props.closePopUpAddPackageResult();
    if (props.isSuccessAddPackage) {
      getCellularList(true);
    }
  };

  const openPopUpAddPackageResult = () => {
    props.openPopUpAddPackageResult();
  };

  return (
    <div className='cellularDataUsageBlock'>
      <Container>
        {props.subscribers && props.subscribers.length > 0 ? (
          <>
            <Row>
              <Col xs='12' sm='12' md='12'>
                <div className='upper-title'>כמה גלשתי</div>
                <h1 className='title'>
                  <span className='new-line'>שימושי גלישה&nbsp;</span>
                  <span className='new-line'>במחזור חיוב נוכחי&nbsp;</span>
                  <span className='new-line'>
                    {props.subscribers[0].cycleStartDate != null
                      ? getFormatDate(new Date(props.subscribers[0].cycleStartDate)) + ' - היום '
                      : ''}{' '}
                  </span>
                </h1>
              </Col>
            </Row>
            <Row>
              <Col xs='12' sm='12' md='12'>
                {props.subscribers.map((item, i) => (
                  <div key={i} className='surfingUseDataItem'>
                    <Row>
                      <Col xs='12' sm='12' md='12'>
                        <div className='subscriber'>
                          <span className='icon'>
                            <Image src={personIcon} />
                          </span>
                          <div className='phoneNumber'>{item.cli}</div>
                        </div>
                      </Col>
                    </Row>
                    {item.errorDesc ? (
                      <Row>
                        <Col xs='12' sm='12' md='12'>
                          <div className='error-wrapper'>
                            {item.errorDesc == 'EmptyDataUsage' && <p>במנוי זה לא נמצאו שימושי גלישת סלולר להצגה</p>}
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <Row>
                          {item.isUnlimited ? (
                            <Col xs='12' sm='12' md='9'>
                              <div className='unlimited-wrapper'>
                                <div className='unlimited-text'>גלשת &nbsp;</div>
                                <div className='unlimited-text unlimited-data-used'>
                                  &nbsp; {item.dataUsage.used} {item.dataUsage.usedUnitOfMeasure}
                                </div>
                                <div className='unlimited-text PT5'>מתוך חבילת הגלישה שלך </div>
                              </div>
                            </Col>
                          ) : (
                            <Col xs='12' sm='12' md='9'>
                              <div className='limited-wrapper'>
                                <div className='status-bar-wrapper'>
                                  <div className='text-wrapper clearfix'>
                                    <div className='text'> גלישה במסגרת החבילה </div>
                                    <div className='capacity'>
                                      {' '}
                                      <span className='used'>
                                        {item.dataUsage.used}
                                        {!item.isSameUnitDataUsage ? item.dataUsage.usedUnitOfMeasure : null}
                                      </span>
                                      /{item.dataUsage.quantity}&nbsp;{item.dataUsage.quantityUnitOfMeasure}
                                    </div>
                                  </div>
                                  <div className='status-bar-bg'>
                                    <Progress value={item.dataUsage.statusBarWidth} />
                                  </div>
                                </div>

                                {item.isDisplayDeviation && (
                                  <div className='status-bar-wrapper deviation data-overhead'>
                                    <div className='text-wrapper clearfix'>
                                      <div className='text'> גלישה מעבר לחבילה </div>
                                      <div className='capacity'>
                                        {' '}
                                        <span className='used'>
                                          {item.dataOverhead.used}
                                          {!item.isSameUnitDataOverhead ? item.dataOverhead.usedUnitOfMeasure : null}
                                        </span>
                                        /{item.dataOverhead.quantity}
                                        {item.dataOverhead.quantityUnitOfMeasure}
                                      </div>
                                    </div>
                                    <div className='status-bar-bg'>
                                      <Progress value={item.dataOverhead.statusBarWidth} />
                                    </div>
                                  </div>
                                )}
                              </div>
                              {item.isDisplayLink && setLinkContent(item)}
                            </Col>
                          )}
                          <Col xs='12' sm='12' md='3'>
                            <div className='cycleRemainingDays'>
                              <Image src={cycleRemainingDaysIcon} />
                              <div className='textCalender'>
                                <div className='days-numbers'>{item.cycleRemainingDays}</div>
                                <div>ימים</div>
                              </div>
                              <div className='text'>
                                נותר עד סוף <br /> מחזור החיוב
                              </div>
                            </div>
                          </Col>
                        </Row>
                        {setPurchaseBox(item)}
                      </>
                    )}
                  </div>
                ))}
              </Col>
            </Row>
            <Row>
              <Col xs='12' sm='12' md='12'>
                <p className='disclimer'>{props.contentData.description.value} </p>
              </Col>
            </Row>
          </>
        ) : (
          <>
            {isFinishedGetSurfingDataUsageDetails && !props.fatalError && notFoundDataUsage()}
            {isFinishedGetSurfingDataUsageDetails && props.fatalError && errorMsg()}
          </>
        )}
        <PopUp
          className='surfing-use-popup'
          showPopUp={props.showPopUpLink}
          onClose={() => {
            closePopUpLink();
          }}>
          <h2>{linkPopUpTitle}</h2>
          <p>{linkPopUpText}</p>
        </PopUp>
        <PopUp
          className='surfing-use-popup'
          showPopUp={props.showPopUpExpanding}
          onClose={() => {
            closePopUpExpanding();
          }}>
          <h2>הרחבת חבילת גלישה</h2>
          {props.isPrivate && (
            <p className='offer-text'>
              האם ברצונך לרכוש תוספת קבועה של {props.contentData.gbPrivate.value}GB לחבילת הגלישה בעלות חודשית של ₪
              {props.contentData.pricePrivate.value} כולל מע"מ?
            </p>
          )}
          {!props.isPrivate && (
            <p className='offer-text'>
              האם ברצונך לרכוש תוספת קבועה של {props.contentData.gbBusiness.value}GB לחבילת הגלישה בעלות חודשית של ₪
              {props.contentData.priceBusiness.value} כולל מע"מ?
            </p>
          )}
          <p>החבילה מתווספת לחבילה המקורית ומתחדשת באופן אוטומטי.</p>
          <div className='btn-wrapper'>
            <BtnWhite onclick={() => closePopUpExpanding()} text='לא, תודה' formid='cellularDataUsage'></BtnWhite>
            <BtnSubmit onclick={() => addPackage()} text='כן, אני רוצה לרכוש' formid='cellularDataUsage'></BtnSubmit>
          </div>
        </PopUp>
        <PopUp
          className='surfing-use-popup'
          showPopUp={props.showPopUpAddPackageResult}
          onClose={() => {
            closePopUpAddPackageResult();
          }}>
          {props.isSuccessAddPackage ? (
            <div className='success-image-wrapper'>
              {/* <Lottie options={{animationData: CheckedAnimation, loop: false}} width={127} height={127} /> */}
              <ThemedLottie animationData={CheckedAnimation} color={ThemeColorEnum.PRIMARY} width={127} height={127} loop={false} />
            </div>
          ) : null}
          {props.isSuccessAddPackage ? (
            <h2 className='success'>הרחבת הגלישה הותקנה בהצלחה</h2>
          ) : (
            <h2 className='failed'>מצטערים, ההתקנה לא הצליחה</h2>
          )}
          {props.isSuccessAddPackage ? (
            <>
              <p className='success'>המשך גלישה נעימה!</p>
              <BtnSubmit onclick={() => closePopUpAddPackageResult()} text='סגירה' formid='cellularDataUsage'></BtnSubmit>
            </>
          ) : (
            <>
              <p className='failed'>
                {' '}
                במידה וכבר רכשת הרחבה לחבילת הגלישה, אין באפשרותך לבצע זאת שוב.
                <br />
                לפרטים נוספים ניתן לפנות למוקד השירות&nbsp;
                {isMobile ? null : window.Config.technicalSupportPhone + ' '}
                בשעות הפעילות.
              </p>
              {isMobile ? (
                <a className='call-btn' href={'tel:*'+ window.Config.technicalSupportPhone}>
                  <span>חייגו {window.Config.technicalSupportPhone}</span>
                </a>
              ) : (
                <BtnSubmit onclick={() => closePopUpAddPackageResult()} text='סגירה' formid='cellularDataUsage'></BtnSubmit>
              )}
            </>
          )}
        </PopUp>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isFullAuthenticated: state.authentication?.loginData?.isFullAuthenticated,
    isPrivate: state.authentication?.loginData?.userDetails?.isPrivate,
    subscribers: state.cellularSurfingUseDetailsBlock?.subscribers,
    fatalError: state.cellularSurfingUseDetailsBlock?.fatalError,
    showPopUpExpanding: state.cellularSurfingUseDetailsBlock?.showPopUpExpanding,
    showPopUpLink: state.cellularSurfingUseDetailsBlock?.showPopUpLink,
    showPopUpAddPackageResult: state.cellularSurfingUseDetailsBlock?.showPopUpAddPackageResult,
    isSuccessAddPackage: state.cellularSurfingUseDetailsBlock?.isSuccessAddPackage,
    selectedSubscriber: state.cellularSurfingUseDetailsBlock?.selectedSubscriber,
  };
};

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
  addPackage,
  getSurfingDataUsageDetails,
  closePopUpExpanding,
  openPopUpExpanding,
  openPopUpLink,
  closePopUpLink,
  openPopUpAddPackageResult,
  closePopUpAddPackageResult,
  setSelectedSubscriber,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(CellularDataUsage);
